import React from 'react';

const Ex2_Model = () => {
    return (
        <div>Ex2_Model Component</div>
    );
}

export default Ex2_Model;
